import { fetchBaseQuery } from "@reduxjs/toolkit/query";

const _baseQuery = fetchBaseQuery({
    baseUrl: "/api/",
    prepareHeaders: (headers) => {
        const token = localStorage.getItem("token");
        if (token) {
            headers.set("Authorization", `Bearer ${token}`);
        }
        return headers;
    }
});
const baseQuery: typeof _baseQuery = async (args, api, extraOptions) => {
    const result = await _baseQuery(args, api, extraOptions);
    if (result.error && result.error.status === 401) {
        window.location.href = "/#/login";
    }
    return result;
}

export default baseQuery;
